<div class="container container-card">
  <div class="row mt-3 mb-3">
      <div class="col-12 txt-center">
          <h2 class="pt-15 pb-15">Gestione Analisi Massiva</h2>
      </div>
  </div>

  <form *ngIf="ready" class="mt-3 fontSizeSmall" [formGroup]="filterForm" >

    <div class="form-row mt-2"> 
      <div class="col">
        <label for="nome_sito">Nome Sito</label>
        <input type="text" class="form-control" placeholder="Nome Sito" formControlName="nome_sito">
      </div>
    
      <div class="col">
        <label for="piano_lavori">Piano Lavori</label>
        <input type="text" class="form-control" placeholder="Piano Lavori" formControlName="piano_lavori">
      </div>
      <div class="col">
        <label for="anno_piano_lavori">Anno Piano Lavori</label>
        <input type="text" class="form-control" placeholder="Anno Piano Lavori" formControlName="anno_piano_lavori">
      </div>
      <div class="col">
        <label for="sr">SR</label>
        <input type="text" class="form-control" placeholder="SR" formControlName="sr">
      </div>
    </div>

    <div class="form-row d-flex mt-3 justify-content-center">
      <div class="col-auto">
        <button (click)="onSubmit()" placement="top" ngbTooltip="Filtra Analisi" class="btn bg-blu txt-white customBtnSize" [disabled]="filterForm.invalid">Filtra</button>
      </div>

      <div class="col-auto">
        <button (click)="onReset()" placement="top" ngbTooltip="Reset Filtri e Risultati Ricerca" class="btn btn-dark customBtnSize">Reset</button>
      </div>
    </div>
  </form>

  <hr>

  <div class="mt-4 d-flex justify-content-between">
    <div>
      <button *ngIf="selectAllBtn; else elseBlock" placement="top" ngbTooltip="Seleziona Tutte le Analisi Filtrate" (click)="onSelectAll()" class="btn btn-sm bg-blu txt-white mr-auto">Seleziona Tutto</button>
      <ng-template #elseBlock>
        <button (click)="onSelectAll()" placement="top" ngbTooltip="Deseleziona Tutte le Analisi Selezionate" class="btn btn-sm bg-blu txt-white mr-auto">Deseleziona Tutto</button>
      </ng-template>
      
      <button (click)="onCallExport()" placement="top" ngbTooltip="Export delle Analisi Filtrate in Formato CSV" class="btn btn-sm bg-blu txt-white btn-sm ml-2" [disabled]="listResults.length === 0">Export CSV</button>
    </div>

    <div class="d-flex">
      <button (click)="onCallAssocia(checkedList);" class="btn bg-blu txt-white ml-2 btn-sm customBtnSize" placement="top" ngbTooltip="Associazione Massiva dei Gruppi alle Analisi Selezionate" [disabled]="checkedList.length === 0">Associa</button>
      <button (click)="onCallMassiveEdit()" class="btn bg-blu txt-white btn-sm ml-2 customBtnSize" placement="top" ngbTooltip="Modifica Massiva dei Campi delle Analisi Selezionate" [disabled]="checkedList.length === 0">Modifica</button>
      <button (click)="onCallMassiveDelete()" class="btn btn-dark btn-sm ml-2 customBtnSize" placement="top" ngbTooltip="Eliminazione Massiva delle Analisi Selezionate" [disabled]="checkedList.length === 0">Elimina</button>
    </div>
  </div>

  <div class="mt-4">
    <ebw-list
      class="fontSizeSmall"
      [token]="token"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [fontawesomeIcons]="icons"
      [listType]="listType"
      [triggerInitialParams]="listChangedTrigger"
      [initialParamsFilters]="listParamsFilters"
      [restApiPath]="restApiPath"
      [listFields]="listFields"
      [listenListDOMChangesInputCheckbox]="true"
      [buttonCSVExport]="false"
      [buttonXMLExport]="false"
      [buttonPDFExport]="false"
      requestMethod="POST"
      (actionClicked)="onAction($event)"
      (listLoaded)="onListLoaded($event)"
      (listValues)="onListValues($event)"
      (checkboxHeaderClicked)="onCheckboxHeaderClicked($event)"
      (checkboxClicked)="onCheckboxClicked($event)"
      (listDOMChanged)="onListDOMChanged($event)"
      #listComponent>
    </ebw-list>
  </div>

</div>